import { Box, CircularProgress, Typography } from '@mui/material';
import { useI18n } from '../../../lib/hook/useI18n';

interface ConversionLoaderProps {
  height?: number;
  theaterMode?: boolean;
}

const ConversionLoader = ({
  height,
  theaterMode = false,
}: ConversionLoaderProps) => {
  const { t } = useI18n();

  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        height: height || theaterMode ? '83vh' : theme.spacing(30),
        overflow: 'hidden',
      })}
    >
      <CircularProgress color="inherit" size={32} sx={{ mb: 1 }} />
      <Typography align="center" gutterBottom variant="h6">
        {t('document.viewer.processing.title')}
      </Typography>
      <Typography align="center" color="textSecondary" variant="body2">
        {t('document.viewer.processing.subtitle')}
      </Typography>
    </Box>
  );
};

export default ConversionLoader;
